"use client";

import {useContext, useState} from "react";
import {Basket} from "../../context/basket";
import { usePathname } from 'next/navigation'

const TvSquared = () => {
    const [loaded, setLoaded] = useState(false);
    const basket = useContext(Basket);
    const quoteId = basket?.data?.quote?.quote?.quote_id;
    const customerId = basket?.data?.customer?.id;
    const pathName = usePathname();

    if (loaded === false && typeof window !== 'undefined' && (quoteId || customerId)) {
        let userId = (typeof customerId === 'undefined') ? quoteId : customerId;
        let _tvq = window._tvq = window._tvq || [];
        (function() {
            let session = {'user':  userId};
            let u = (("https:" === document.location.protocol) ? "https://collector-7380.tvsquared.com/" :
                "http://collector-7380.tvsquared.com/");
            _tvq.push(['setSiteId', "TV-27631890-1"]);
            _tvq.push(['setCookieDomain', "sons.co.uk"]);
            _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
            _tvq.push([function() {
                this.setCustomVariable(5, 'session', JSON.stringify(session), 'visit')
            }]);

            if (pathName.includes('consultation')) {
                let payload = {};

                // Send available data to TvSquared if we have it.
                if (basket?.data?.quote?.quote) {
                    const quoteData = basket?.data?.quote?.quote;
                    let products = quoteData.items.map(function (item) {
                        return item.product_name;
                    });

                    payload = {
                        'rev': quoteData.grand_total,
                        'prod': products.toString(),
                        'id': quoteData.quote_id,
                        'promo': ''
                    }
                }

                _tvq.push([function() {
                    this.setCustomVariable(5, 'startconsultation', JSON.stringify(payload), 'page')
                }]);
            }

            _tvq.push(['trackPageView']);
            let d = document,
                g = d.createElement('script'),
                s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.defer = true;
            g.async = true;
            g.src = u + 'tv2track.js';
            s.parentNode.insertBefore(g, s);
        })();

        setLoaded(true);
    }
};

export default TvSquared;